import actions from './actions';
import reducer from './reducer';

const entities = {
    actions,
    reducer,
    name: 'entities',
};

export default entities; 